import { CircularProgress, TableCell, TableRow } from '@mui/material';
import React from 'react'
import { useThemeMode } from '../theme';

const TableLoader = ({columnsLength}) => {
    const { colours } = useThemeMode();
    return (
        <TableRow>
            <TableCell colSpan={columnsLength}>
                <div
                    style={{
                        fontWeight: "bold",
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    <CircularProgress style={{ color: colours.primary100 }} />
                </div>
            </TableCell>
        </TableRow>
    )
}

export default TableLoader;